export var DAY_HEIGHT = 41;
export var LIST_HEIGHT = 362;
export var MONTH_TITLE_HEIGHT = 55;